// External Dependencies.
import { useDispatch, useSelect } from '@wordpress/data';
import { __ } from '@wordpress/i18n';
import { SUBSCRIPTIONS_STORE_NAME as STORE_NAME } from '../../constants';
import { useState } from '@wordpress/element';

// Internal Dependencies.
import Button from '@wds/blocks/common/popup/Button';
import LoadingMask from '@wds/blocks/common/LoadingMask';
import SubscriptionMonthlySelector from './SubscriptionMonthlySelector';
import { isTimeslotEnabled, isTimeslotMandatory } from '../../common/helper';
import { saveSubscriptionData } from '../../common/api';
import { updateCheckout } from '../subscriptionHelper';


const SubscriptionPopupContent = () => {
	const [isLoading, setIsLoading] = useState(false);
	const type = useSelect(select => select(STORE_NAME).getPopupOpen());
	const {setPopupOpen, setReservedSlot} = useDispatch(STORE_NAME);
	const subscriptionData = useSelect(select => select(STORE_NAME).getSubscriptionData());
	const dateYmd = useSelect(select => select(STORE_NAME).getDateYmd(type));
	const timeslot = useSelect(select => select(STORE_NAME).getTimeslot(type));
	const products = useSelect(select => select(STORE_NAME).getProducts(type));

	if ( !subscriptionData ) {
		return null;
	}
	
	const timeslotEnabled = isTimeslotEnabled();
	const timeslotMandatory = isTimeslotMandatory();

	const isBtnDisabled = () => {
		if (!dateYmd) {
			return true;
		}

		if (dateYmd && !timeslotEnabled) {
			return false;
		}

		if (timeslotMandatory && !timeslot) {
			return true;
		}

		return false;
	}

	const handleSave = async () => {
		setIsLoading(true);
		
		const productIds = Object.keys(products);

		try {
			const reservedSlot = await saveSubscriptionData( dateYmd, timeslot, productIds, type );
			setReservedSlot( type, reservedSlot );
			setPopupOpen(false);
		} catch (error) {
			alert(error.message);
		} finally {
			setIsLoading( false );
			updateCheckout();
		}
	}
	

	return (
		<LoadingMask loading={isLoading}>
			<div>
				<SubscriptionMonthlySelector type={type}/>
				
				<Button
					className="wds-fieldbox__save-btn"
					isDisabled={isBtnDisabled()}
					onClick={handleSave}
				>
					{__('Save Changes', 'jckwds')}
				</Button>
			</div>
		</LoadingMask>
	);
};

export default SubscriptionPopupContent;